import * as types from './mutation-types';
import initState from './state';

export default {
  // LOGOUT
  [types.LOGOUT](state) {
    Object.assign(state, initState());
  },

  // KNOWLEDGE
  [types.SET_KNOWLEDGES](state, payload) {
    state.knowledges = payload;
  },
  [types.SET_FOCUS_KNOWLEDGE](state, payload) {
    state.focusKnowledge = payload;
  },
  [types.SET_FOCUS_KNOWLEDGE_ROOTS](state, payload) {
    state.focusKnowledgeRoots = payload;
  },
  [types.INIT_KNOWLEDGE](state, payload) {
    // state.favoriteTreeNodes = payload.favoriteTreeNodes;
    state.focusKnowledge = payload.focusKnowledge;
    state.companyPreferences = payload.companyPreferences;
    state.reachableUsers = payload.reachableUsers;
    state.reachableRoles = payload.reachableRoles;
    // state.searchAccess = payload.searchAccess;
  },
  [types.UPDATE_KNOWLEDGE](state, payload) {
    state.focusKnowledge = payload.focusKnowledge;
    state.companyPreferences = payload.companyPreferences;
    state.reachableUsers = payload.reachableUsers;
    state.reachableRoles = payload.reachableRoles;
  },

  // NAVIGATION
  [types.SET_NAVIGATION_LANGUAGE](state, language) {
    state.navigationLanguage = language;
  },

  [types.UPDATE_PATH](state, path) {
    state.path = path;
  },
  [types.UPDATE_DIAG_PATH](state, diagPath) {
    state.diagPath = diagPath;
  },
  [types.SET_FOCUS_NAV_ITEM](state, item) {
    if (!item) return (state.focusNavItem = null);

    // Quick dirty fix to reduce store size, we use body from focusDiagItem now instead
    // Since focusDiagItem is always equal to focusNavItem when navigating into Article
    // Only place it was used : ArticleView component
    // eslint-disable-next-line no-unused-vars
    const { body, ...payload } = item;
    state.focusNavItem = payload;
  },
  [types.SET_FOCUS_DIAG_ITEM](state, diagItem) {
    state.focusDiagItem = diagItem;
  },
  [types.UPDATE_PREVIOUS_ITEMS](state, previousItems) {
    state.previousItems = previousItems;
  },

  // SEARCH
  [types.UPDATE_SEARCH_QUERY](state, query) {
    state.query = query;
  },
  [types.UPDATE_SEARCH_FILTERS](state, filters) {
    state.filters = filters;
  },
  [types.UPDATE_SEARCH_FOCUS_LEVEL](state, focusLevel) {
    state.focusLevel = focusLevel;
  },
  [types.UPDATE_SEARCH_SIZE](state, size) {
    state.size = size;
  },
  [types.UPDATE_SEARCH_RESULTS](state, { results, totalCount }) {
    state.results = results;
    state.totalCount = totalCount;
  },
  [types.UPDATE_RECENT_SEARCHES](state, search) {
    let recentSearches = [...state.recentSearches];

    recentSearches.unshift(search);
    recentSearches = recentSearches.slice(0, 5);

    state.recentSearches = recentSearches;
  },

  [types.UPDATE_FREQUENT_SEARCHES](state, frequentSearches) {
    state.frequentSearches = frequentSearches;
  },

  // LOADING
  [types.SET_LOADING](state, loading) {
    state.loading = loading;
  },

  // USER
  [types.UPDATE_FAVORITES](state, favorites) {
    state.userFavorites = favorites;
  },
  [types.SET_USER_INFOS](state, payload) {
    state.userFavorites = payload.favoriteEntities;
    state.reachableUsers = payload.company.reachableUsers;
    state.reachableRoles = payload.company.reachableRoles;
    state.lastUserInfosRefresh = payload.lastUserInfosRefresh;
  },
};
